"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NegativeBalances = void 0;
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const negative_balances_header_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/negative-balances/components/negative-balances-header");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
const router_1 = require("client/components/router");
const store_2 = require("client/modules/eob/store");
const mobx_1 = require("mobx");
const number_formatter_1 = require("../claim-analytics/number-formatter");
require("./negative-balances.less");
let NegativeBalances = class NegativeBalances extends React.Component {
    constructor(props) {
        super(props);
        this.selectedRows = [];
        this.onButtonExport = () => {
            const params = {
                fileName: "Negative_Balances.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.onButtonPayBack = (selectedRowsArray) => {
            // console.log("button array", selectedRowsArray);
            store_2.eobStore.showPayback = true;
            store_2.eobStore.selectedRowsPayback = selectedRowsArray;
            router_1.RouteManager.transitionTo(`/eob/eobpayback`);
        };
        this.storeData = {
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    else {
                        return a > b ? 1 : a < b ? -1 : 0;
                    }
                }
            },
            columnDefs: [
                {
                    headerName: "Pharmacy Name",
                    field: "PharmacyName",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true,
                    checkboxSelection: true,
                    headerCheckboxSelection: true
                },
                {
                    headerName: "Payer Name",
                    field: "PayerName",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "RX Number",
                    field: "RXNumber",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Date of Service",
                    field: "DateofService",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                },
                {
                    headerName: "Patient Bin",
                    field: "PatientBin",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Patient PCN",
                    field: "PatientPCN",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Patient Group Id",
                    field: "PatientGroupId",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Reimb Amount",
                    field: "ReimbAmount",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "POS Fees",
                    field: "posFees",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "DIR Fees",
                    field: "dirFees",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "Check Date",
                    field: "EOBDate",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                },
                {
                    headerName: "Days Open",
                    field: "DaysOpen",
                    filter: "agNumberColumnFilter"
                },
                {
                    headerName: "Check Number",
                    field: "CheckNumber",
                    filter: "agTextColumnFilter"
                }
            ],
            rowSelection: "multiple",
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            }
        };
    }
    async componentDidMount() {
        await store_1.reportsStore.loadNegativeBalances();
    }
    componentWillUnmount() {
        store_1.reportsStore.negativeBalancesData = null;
    }
    render() {
        const storeData = store_1.reportsStore.negativeBalancesData;
        this.storeData.rowData = storeData;
        const loadingData = store_1.reportsStore.showLoader;
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(negative_balances_header_1.NegativeBalancesHeader, { title: "Negative Balances Report", withDatePicker: true }),
                React.createElement("div", { className: "test-header" },
                    "Selected Rx Numbers To Pay Back:",
                    React.createElement("span", { id: "selectedRows" })),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement("hr", null),
                    React.createElement("button", { onClick: this.onButtonPayBack.bind(this, this.selectedRows) }, "Pay Insurance Back"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => (this.storeData.gridApi = params.api), columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, frameworkComponents: this.storeData.frameworkComponents, multiSortKey: this.storeData.multiSortKey, animateRows: true, sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, suppressExcelExport: true, rowSelection: this.storeData.rowSelection, onSelectionChanged: this.onSelectionChanged.bind(this), rowMultiSelectWithClick: true, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(negative_balances_header_1.NegativeBalancesHeader, { title: "Negative Balances Report", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(negative_balances_header_1.NegativeBalancesHeader, { title: "Negative Balances Report", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
    onSelectionChanged() {
        this.selectedRows = this.storeData.gridApi.getSelectedRows();
        console.log("selected rows:", this.selectedRows);
        let selectedRowsString = "";
        this.selectedRows.forEach((selectedRow, index) => {
            if (index !== 0) {
                selectedRowsString += ", ";
            }
            selectedRowsString += selectedRow.RXNumber;
        });
        document.querySelector("#selectedRows").innerHTML = selectedRowsString;
    }
};
__decorate([
    mobx_1.observable
], NegativeBalances.prototype, "selectedRows", void 0);
NegativeBalances = __decorate([
    mobx_react_1.observer
], NegativeBalances);
exports.NegativeBalances = NegativeBalances;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/negative-balances/negative-balances.tsx
// module id = 3919
// module chunks = 0